import sticker1 from "../images/default stickers/TvShowBanner (1).png";
import sticker2 from "../images/default stickers/TvShowBanner (2).png";
import sticker3 from "../images/default stickers/TvShowBanner (3).png";
import sticker4 from "../images/default stickers/TvShowBanner (4).png";
import sticker5 from "../images/default stickers/TvShowBanner (5).png";
import sticker6 from "../images/default stickers/TvShowBanner (6).png";
import sticker7 from "../images/default stickers/TvShowBanner (7).png";
import sticker8 from "../images/default stickers/TvShowBanner (8).png";
import sticker9 from "../images/default stickers/TvShowBanner (9).png";
import sticker10 from "../images/default stickers/TvShowBanner (10).png";
import sticker11 from "../images/default stickers/TvShowBanner (11).png";
import sticker12 from "../images/default stickers/TvShowBanner (12).png";
import sticker13 from "../images/default stickers/TvShowBanner (13).png";
import sticker14 from "../images/default stickers/TvShowBanner (14).png";
import sticker15 from "../images/default stickers/TvShowBanner (15).png";
import sticker16 from "../images/default stickers/TvShowBanner (16).png";
import sticker17 from "../images/default stickers/TvShowBanner (17).png";
import sticker18 from "../images/default stickers/TvShowBanner (18).png";
import sticker19 from "../images/default stickers/TvShowBanner (19).png";
import sticker20 from "../images/default stickers/TvShowBanner (20).png";

export let default_stickers = [
  sticker1,
  sticker2,
  sticker3,
  sticker4,
  sticker5,
  sticker6,
  sticker7,
  sticker8,
  sticker9,
  sticker10,
  sticker11,
  sticker12,
  sticker13,
  sticker14,
  sticker15,
  sticker16,
  sticker17,
  sticker18,
  sticker19,
  sticker20,
];
